import { useTranslation } from 'react-i18next'
// eslint-disable-next-line lodash/import-scope
import _ from 'lodash'

import { Reports } from '../../../containers/CompanyDetail/Reports'
import { Company } from '../../../redux/companyDetail/types'
import { useDateFormat } from '../../../hooks/useDateFormat'

import { maxDayRenderDeliveryOptionLabel } from '../../utils/config'

import { CompanyDetailPageConfig, CompanyDetailFields, defaultFormatAddress } from './config'

export function useCompanyDetailPageConfig(country: string): CompanyDetailPageConfig {
  const { t } = useTranslation('companyDetail')
  const { formatDate } = useDateFormat()

  return {
    generateFields: (c: Company) => {
      const ret: CompanyDetailFields = {
        notAuthFields: _.filter(
          [
            {
              label: t('Tradestyle'),
              value: c.tradestyle ?? ''
            },
            {
              label: t('Country'),
              value: country
            },
            {
              label: t('City'),
              value: c.hqAddress?.city ?? ''
            },
            {
              label: t('Address'),
              value:
                c.hqAddress?.street && c.hqAddress?.houseNumber
                  ? `${c.hqAddress?.street} ${c.hqAddress?.houseNumber}`
                  : c.hqAddress?.fullAddress
                    ? c.hqAddress?.fullAddress
                    : ''
            },
            {
              label: t('CompanyUnitType'),
              value: c.companyUnitType ?? ''
            },
            {
              label: t('SecCode'),
              value: c.sec ?? ''
            },
            {
              label: t('DtiCode'),
              value: c.dti ?? ''
            },
            {
              label: t('CdaCode'),
              value: c.cda ?? ''
            },
            {
              label: t('Industry'),
              value: c.sic
            },
            {
              label: t('LegalForm'),
              value: c.legalForm
            },
            {
              label: t('IncorporationDate'),
              value: c.incorporationDate
                ? formatDate(c.incorporationDate, {
                    dateStyle: 'medium'
                  })
                : ''
            },
            {
              label: t('LastUpdateDate'),
              value: c.lastUpdateDate
                ? formatDate(c.lastUpdateDate, {
                    dateStyle: 'medium'
                  })
                : ''
            },
            {
              label: t('LastFinancialStatement'),
              value: c.lastFinancialStatement
                ? formatDate(c.lastFinancialStatement, {
                    dateStyle: 'medium'
                  })
                : ''
            },
            {
              label: t('RegistrationCode'),
              value: c.registrationCodes ?? '',
              maxItems: 3
            }
          ],
          x => !_.isEmpty(x.value)
        ),
        authFields: []
      }

      return ret
    },
    tabs: [
      {
        key: 1,
        title: t('Tabs.Reports'),
        component: Reports,
        componentProps: {
          renderDeliveryOptionLabel: maxDayRenderDeliveryOptionLabel
        }
      },
      {
        key: 2,
        title: t('Tabs.Financial')
      },
      {
        key: 3,
        title: t('Tabs.CompanyNetwork')
      },
      {
        key: 4,
        title: t('Tabs.Industry')
      }
    ],
    formatAddress: defaultFormatAddress
  }
}
